import { render, staticRenderFns } from "./background-display.vue?vue&type=template&id=07eec638&"
import script from "./background-display.vue?vue&type=script&lang=js&"
export * from "./background-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports